"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _colors = require("@material-ui/core/colors");

var _reflux = _interopRequireDefault(require("reflux"));

var _config = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/config.js"));

var _strings = require("./strings");

var _AlertHelper = require("../../../helpers/AlertHelper");

var _MuiAlertHelper = require("../../../helpers/MuiAlertHelper");

var _OverlaySpinner = _interopRequireDefault(require("../Spinner/OverlaySpinner"));

var _SettingsCordova = _interopRequireDefault(require("./SettingsCordova.scss"));

var _ThemeStore = _interopRequireDefault(require("../ThemeStore/ThemeStore2"));

var _DataStore = _interopRequireWildcard(require("../../../KESI2/Stores/DataStore2"));

var _ObjectHelper = require("../../../helpers/ObjectHelper");

var _ColorHelper = require("../../../helpers/ColorHelper");

var _index = _interopRequireDefault(require("../Button/index"));

var _TimeoutHelper = require("../../../helpers/TimeoutHelper");

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _NavigationManagerCordova = _interopRequireDefault(require("../../NavigationManagerCordova"));

var _FormGroup = _interopRequireDefault(require("@material-ui/core/FormGroup"));

var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _Switch = _interopRequireDefault(require("@material-ui/core/Switch"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _AppUtils = require("../../../utils/AppUtils");

var _DataStoreComponent2 = _interopRequireDefault(require("../DataStoreComponent/DataStoreComponent2"));

var _QRCode = require("../../../helpers/QRCode");

var _cssConstants = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/cssConstants.js"));

var _ContentStore = _interopRequireDefault(require("../../../KESI2/Stores/ContentStore"));

var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));

var _QRCodeLogin = _interopRequireDefault(require("../QRCodeLogin/QRCodeLogin"));

var _QRCodeReferrer = _interopRequireDefault(require("../QRCodeReferrer/QRCodeReferrer"));

var _pickers = require("@material-ui/pickers");

var _moment = _interopRequireDefault(require("@date-io/moment"));

var _Select = _interopRequireDefault(require("@material-ui/core/Select"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _createMuiTheme = _interopRequireDefault(require("@material-ui/core/styles/createMuiTheme"));

var _ThemeProvider = _interopRequireDefault(require("@material-ui/styles/ThemeProvider"));

var _KESI2Helper = _interopRequireDefault(require("../../../KESI2/KESI2Helper"));

var SettingsHelper = _interopRequireWildcard(require("../../../helpers/SettingsHelper"));

var _DrupalNugget = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/DrupalNugget.js"));

var _PreconditionChecker = require("../../../utils/PreconditionChecker");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var getDeviceUuidVisiblePart = function getDeviceUuidVisiblePart(deviceUuid) {
  if (deviceUuid.split) {
    var parts = deviceUuid.split('-');

    if (parts.length > 0) {
      return parts[parts.length - 1];
    }
  }

  return null;
};

var MAIL_ID = 'mail'; // TODO put styling into target
// const muiStyles = theme => ({
//   switchLabel: {
//     color: 'black',
//     fontSize: 'inherit'
//   },
//   colorSwitchBase: {
//     color: blue[300],
//     '&$colorChecked': {
//       color: blue[500],
//       '& + $colorBar': {
//         backgroundColor: blue[500]
//       }
//     }
//   },
//   colorBar: {},
//   colorChecked: {},
//   container: {
//     lineHeight: '29px',
//     display: 'flex',
//     flexWrap: 'wrap'
//   },
//   textField: {
//     marginLeft: theme.spacing.unit,
//     marginRight: theme.spacing.unit,
//     width: 75
//   }
// })

var SwitchWithStyles = (0, _withStyles["default"])(function (theme) {
  return {
    root: {
      marginTop: 20,
      marginLeft: 10,
      width: 60,
      height: 30,
      padding: 0,
      display: 'flex'
    },
    switchLabel: {
      color: _cssConstants["default"].colors.buttonCaption,
      fontSize: '16px'
    },
    switchBase: {
      padding: 2,
      color: theme.palette.grey[500],
      '&$checked': {
        transform: 'translateX(30px)',
        color: theme.palette.common.white,
        '& + $track': {
          opacity: 1,
          backgroundColor: _cssConstants["default"].colors.buttonBackground,
          borderColor: _cssConstants["default"].colors.buttonBackground
        }
      }
    },
    thumb: {
      width: 26,
      height: 26,
      boxShadow: 'none'
    },
    track: {
      border: "1px solid ".concat(theme.palette.grey[500]),
      borderRadius: 30 / 2,
      opacity: 1,
      backgroundColor: theme.palette.common.white
    },
    checked: {}
  };
})(_Switch["default"]);
var LabelWithStyles = (0, _withStyles["default"])({
  label: {
    fontSize: '16px',
    color: _cssConstants["default"].colors.buttonBackground,
    paddingLeft: '10px',
    lineHeight: '40px',
    verticalAlign: 'middle',
    marginTop: '18px',
    fontWeight: 'bold'
  }
})(_FormControlLabel["default"]);
var muiStyles = {
  switchLabel: {
    color: 'black',
    fontSize: 'inherit'
  },
  colorSwitchBase: {
    color: _colors.blue[300],
    '&$colorChecked': {
      color: _colors.blue[500],
      '& + $colorBar': {
        backgroundColor: _colors.blue[500]
      }
    }
  },
  colorBar: {},
  colorChecked: {},
  container: {
    lineHeight: '29px',
    display: 'flex',
    flexWrap: 'wrap'
  },
  pickerContainer: {
    width: '80%',
    margin: '20px auto'
  },
  textField: {
    marginLeft: 15,
    // number was guessed
    marginRight: 15,
    // number was guessed
    width: 75
  }
};

var SettingsCordova = /*#__PURE__*/function (_DataStoreComponent) {
  (0, _inherits2["default"])(SettingsCordova, _DataStoreComponent);

  var _super = _createSuper(SettingsCordova);

  function SettingsCordova(props) {
    var _thisSuper, _thisSuper2, _this;

    (0, _classCallCheck2["default"])(this, SettingsCordova);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "goUp", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _TimeoutHelper.timeout)();

            case 2:
              if (_this.props.setTitle) {
                _this.props.setTitle(null);
              }

              return _context.abrupt("return", _NavigationManagerCordova["default"].jumpBack());

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateAppContent", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return _this.props.updateContent(true, true, null, true);

            case 3:
              _context2.next = 9;
              break;

            case 5:
              _context2.prev = 5;
              _context2.t0 = _context2["catch"](0);
              console.log('error', _context2.t0);
              (0, _AlertHelper.showAlertWithOptions)({
                message: (0, _strings.getString)('ERROR_LOADING_CONTENT'),
                title: (0, _strings.getString)('ERROR')
              });

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 5]]);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getStyles", function () {
      var theme = null;

      if (_this.state.navbar && _this.state.currentTheme in _this.state.navbar) {
        theme = _this.state.navbar[_this.state.currentTheme];
      }

      var defaultTheme = _this.state.navbar ? _this.state.navbar["default"] : null;
      return {
        color: (0, _ObjectHelper.getObjectValueWithFallbacks)(theme, 'navbarText', defaultTheme, 'navbarText', _ColorHelper.COLOR.BLACK)
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "logOut", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
      var params;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _DataStore["default"].resetStore();

            case 2:
              params = {
                loggedOut: 'true'
              };

              _NavigationManagerCordova["default"].goHome(true, params);

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "showUserAgreement", function () {
      (0, _AlertHelper.showWideAlertHtml)((0, _strings.getString)('USER_AGREEMENT_TEXT'), (0, _strings.getString)('USER_AGREEMENT_TITLE'), false, [{
        label: (0, _strings.getString)('OK'),
        callback: function callback() {}
      }]);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "showDataPrivacy", function () {
      (0, _AlertHelper.showWideAlertHtml)((0, _strings.getString)('DATA_PRIVACY_TEXT'), (0, _strings.getString)('DATA_PRIVACY_TITLE'), false, [{
        label: (0, _strings.getString)('OK'),
        callback: function callback() {}
      }]);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "showImprint", function () {
      if (_config["default"].imprintLink) {
        window.open(_config["default"].imprintLink, '_system');
      } else {
        (0, _AlertHelper.showWideAlertHtml)((0, _strings.getString)('IMPRINT_TEXT'), (0, _strings.getString)('IMPRINT_TITLE'), false, [{
          label: (0, _strings.getString)('OK'),
          callback: function callback() {}
        }]);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "resetTest", function () {
      (0, _AlertHelper.showWideAlertHtml)((0, _strings.getString)('RESET_TEST_TEXT'), (0, _strings.getString)('RESET_TEST'), false, [{
        label: (0, _strings.getString)('OK'),
        callback: function () {
          var _callback = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
            var data;
            return _regenerator["default"].wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    data = {};
                    data['public.equeodemo.question'] = {};
                    data['public.equeodemo.surveyFilled'] = false;

                    if (_config["default"].quizStorePath) {
                      data[_config["default"].quizStorePath] = {};
                    }

                    _context4.next = 6;
                    return _DataStore["default"].setData(data);

                  case 6:
                    _NavigationManagerCordova["default"].goHome();

                  case 7:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4);
          }));

          function callback() {
            return _callback.apply(this, arguments);
          }

          return callback;
        }()
      }, {
        label: (0, _strings.getString)('CANCEL'),
        callback: function callback() {}
      }]);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "showElInAlert", function (nuggetId, element) {
      var closeDialog = function closeDialog() {
        dialog();
      };

      console.log('showElInAlert', nuggetId, element);
      var dialog = (0, _MuiAlertHelper.showAlertWithOptions)({
        title: element ? element.title : '',
        react: /*#__PURE__*/_react["default"].createElement(_DrupalNugget["default"], {
          key: nuggetId,
          id: nuggetId,
          registerNugget: function registerNugget() {},
          markAsRead: function markAsRead() {},
          contentPathArray: [],
          closePrevDialogFn: closeDialog
        }),
        buttons: []
      });
    });
    _this.state = {
      showSpinner: false,
      initialized: false,
      errorMessage: null,
      appName: '',
      version: null,
      appUpdate: null,
      deviceUuidVisible: null,
      features: null
    };
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(SettingsCordova.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.LOGGED_IN, _DataStore.DATA_STORE_PATHS.SCHICHTBOX_START_DATE, _DataStore.DATA_STORE_PATHS.SCHICHTBOX_EARLY_PUSH_TIME, _DataStore.DATA_STORE_PATHS.SCHICHTBOX_LATE_PUSH_TIME, _DataStore.DATA_STORE_PATHS.ERGO_ACTIVATED]);
    (0, _get2["default"])((_thisSuper2 = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(SettingsCordova.prototype)), "addStoresAndKeys", _thisSuper2).call(_thisSuper2, [{
      store: _ThemeStore["default"],
      keys: ['currentTheme', 'navbar', 'button']
    }]);
    return _this;
  }

  (0, _createClass2["default"])(SettingsCordova, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      console.log('settings cordova did mount');

      _NavigationManagerCordova["default"].setNavbarBackgroundColor(null);

      if (this.props.setTitle) {
        this.props.setTitle(_config["default"].settingsTitle ? _config["default"].settingsTitle : 'Einstellungen');
      }

      if (this.props.setBackButtonFunc) {
        this.props.setBackButtonFunc(this.goUp);
      }

      if (_config["default"].showBottomBarOnlyInLecturesAndSpocs) {
        (0, _AppUtils.hideBottomBar)(true);
      }
    }
  }, {
    key: "renderTargetAndDrupalSettingsItems",
    value: function renderTargetAndDrupalSettingsItems() {
      var _this2 = this;

      var onlineSettings = _KESI2Helper["default"].getSettingsConfig() || [];
      var mappedOnlineSettings = SettingsHelper.translateOnlineSettings(onlineSettings);

      var drupalContentSettingsObj = _KESI2Helper["default"].getContentByKeyword('drupalsettings');

      console.log('drupalsettingsobj', drupalContentSettingsObj);
      var drupalContentSettings = [];

      if (drupalContentSettingsObj && drupalContentSettingsObj.nuggetIds && drupalContentSettingsObj.nuggetIds.length > 0) {
        drupalContentSettingsObj.nuggetIds.forEach(function (nuggetId) {
          var element = _KESI2Helper["default"].getContentById(nuggetId);

          var failingPrecondition = null;

          if (element.showPrecondition) {
            failingPrecondition = (0, _PreconditionChecker.getFailingPrecondition)(element.showPrecondition);
          }

          if (!failingPrecondition) {
            drupalContentSettings.push({
              label: element.title,
              callback: function callback() {
                return _this2.showElInAlert(nuggetId, element);
              }
            });
          }
        });
      }

      var settingsToReturn = [].concat((0, _toConsumableArray2["default"])(mappedOnlineSettings), (0, _toConsumableArray2["default"])(_config["default"].extraSettingsItemsGetter()), drupalContentSettings);
      return settingsToReturn.map(function (extraSetting, index) {
        if (extraSetting.hidden || extraSetting.condition && !extraSetting.condition()) {
          return null;
        }

        if (extraSetting.type === 'updateContent') {
          return /*#__PURE__*/_react["default"].createElement(_index["default"], {
            className: _SettingsCordova["default"].contentButton,
            onClick: _this2.updateAppContent
          }, (0, _strings.getString)('UPDATE_APP_CONTENT'));
        }

        if (extraSetting.type === 'imprint' && _config["default"].showEqueoImprint) {
          return /*#__PURE__*/_react["default"].createElement(_index["default"], {
            className: _SettingsCordova["default"].contentButton,
            onClick: _this2.showImprint
          }, (0, _strings.getString)('SHOW_IMPRINT'));
        }

        if (extraSetting.type === 'imprint' && _config["default"].imprintLink) {
          return /*#__PURE__*/_react["default"].createElement(_index["default"], {
            className: _SettingsCordova["default"].contentButton,
            onClick: _this2.showImprint
          }, (0, _strings.getString)('SHOW_IMPRINT'));
        }

        if (extraSetting.type === 'dataPrivacy' && _config["default"].showEqueoDataPrivacy) {
          return /*#__PURE__*/_react["default"].createElement(_index["default"], {
            className: _SettingsCordova["default"].contentButton,
            onClick: _this2.showDataPrivacy
          }, (0, _strings.getString)('SHOW_DATA_PRIVACY'));
        }

        if (extraSetting.type === 'userAgreement' && _config["default"].showEqueoUserAgreement) {
          return /*#__PURE__*/_react["default"].createElement(_index["default"], {
            className: _SettingsCordova["default"].contentButton,
            onClick: _this2.showUserAgreement
          }, (0, _strings.getString)('SHOW_USER_AGREEMENT'));
        }

        if (extraSetting.type === 'switch') {
          if (extraSetting.listenToPaths) {
            extraSetting.listenToPaths.forEach(function (path) {
              var index = _this2.dataStorePaths.indexOf(path);

              if (index === -1) {
                _this2.dataStorePaths.push(path);
              }

              (0, _get2["default"])((0, _getPrototypeOf2["default"])(SettingsCordova.prototype), "setDataStorePaths", _this2).call(_this2, _this2.dataStorePaths);
            });
          }

          return /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], {
            key: "extraSettingsItem-".concat(index)
          }, /*#__PURE__*/_react["default"].createElement(LabelWithStyles, {
            control: /*#__PURE__*/_react["default"].createElement(SwitchWithStyles, {
              checked: extraSetting.getValue(),
              onChange: extraSetting.onChange
            }),
            label: extraSetting.label
          }));
        }

        if (extraSetting.type === 'timepicker') {
          var theme = (0, _createMuiTheme["default"])({
            overrides: {
              MuiPickersToolbar: {
                toolbar: {
                  backgroundColor: _cssConstants["default"].colors.buttonBackground
                }
              },
              MuiPickersClock: {
                pin: {
                  backgroundColor: _cssConstants["default"].colors.buttonBackground
                }
              },
              MuiPickersClockPointer: {
                pointer: {
                  backgroundColor: _cssConstants["default"].colors.buttonBackground
                },
                thumb: {
                  backgroundColor: _cssConstants["default"].colors.buttonBackground,
                  border: "14px solid ".concat(_cssConstants["default"].colors.buttonBackground)
                },
                noPoint: {
                  backgroundColor: _cssConstants["default"].colors.buttonBackground
                }
              },
              MuiButton: {
                label: {
                  color: _cssConstants["default"].colors.buttonBackground
                }
              }
            }
          });
          return /*#__PURE__*/_react["default"].createElement("div", {
            style: muiStyles.pickerContainer
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: _SettingsCordova["default"].pickerTitle
          }, extraSetting.title ? extraSetting.title : null), /*#__PURE__*/_react["default"].createElement("div", {
            className: _SettingsCordova["default"].pickerInfo
          }, extraSetting.info ? extraSetting.info : null), /*#__PURE__*/_react["default"].createElement(_ThemeProvider["default"], {
            theme: theme
          }, /*#__PURE__*/_react["default"].createElement(_pickers.MuiPickersUtilsProvider, {
            utils: _moment["default"]
          }, /*#__PURE__*/_react["default"].createElement(_pickers.TimePicker, {
            ampm: false,
            label: extraSetting.label,
            minutesStep: 5,
            value: extraSetting.getValue(),
            onChange: extraSetting.onChange,
            okLabel: 'OK',
            cancelLabel: 'Abbrechen'
          }))));
        }

        if (extraSetting.type === 'select') {
          var _extraSetting$maxValu = extraSetting.maxValue,
              maxValue = _extraSetting$maxValu === void 0 ? 19 : _extraSetting$maxValu;
          var possibleDays = (0, _toConsumableArray2["default"])(Array(maxValue + 1).keys());
          return /*#__PURE__*/_react["default"].createElement("div", {
            style: muiStyles.pickerContainer
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: _SettingsCordova["default"].pickerTitle
          }, extraSetting.title ? extraSetting.title : null), /*#__PURE__*/_react["default"].createElement("div", {
            className: _SettingsCordova["default"].pickerInfo
          }, extraSetting.info ? extraSetting.info : null), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
            value: extraSetting.getValue(),
            onChange: extraSetting.onChange
          }, possibleDays.map(function (dayNumber) {
            return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
              value: dayNumber
            }, dayNumber);
          })));
        }

        return /*#__PURE__*/_react["default"].createElement(_index["default"], {
          key: "extraSettingsItem-".concat(index),
          className: _SettingsCordova["default"].contentButton,
          onClick: extraSetting.callback
        }, extraSetting.label);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var themeStyles = this.getStyles();
      var spinner = (0, _OverlaySpinner["default"])();
      var loggedIn = this.state.data[_DataStore.DATA_STORE_PATHS.LOGGED_IN];

      if (_config["default"].useOnlyTargetSettings) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _DeviceInfoHelper["default"].isInternetExplorer() ? _SettingsCordova["default"].ieContainer : _SettingsCordova["default"].settingsContainer,
          style: {
            backgroundColor: _cssConstants["default"].colors.backgroundColor
          }
        }, this.state.showSpinner ? spinner : null, /*#__PURE__*/_react["default"].createElement("div", {
          className: _SettingsCordova["default"].list,
          style: themeStyles
        }, this.renderTargetAndDrupalSettingsItems()));
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _DeviceInfoHelper["default"].isInternetExplorer() ? _SettingsCordova["default"].ieContainer : this.props.isEmbedded ? _SettingsCordova["default"].embeddedContainer : _SettingsCordova["default"].settingsContainer,
        style: {
          backgroundColor: _cssConstants["default"].colors.backgroundColor
        }
      }, this.state.showSpinner ? spinner : null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _SettingsCordova["default"].list,
        style: themeStyles
      }, _DeviceInfoHelper["default"].isBrowser() ? null : /*#__PURE__*/_react["default"].createElement(_index["default"], {
        className: _SettingsCordova["default"].contentButton,
        onClick: this.updateAppContent
      }, (0, _strings.getString)('UPDATE_APP_CONTENT')), _config["default"].hasQRCodeScannerInSettings && !_DeviceInfoHelper["default"].isBrowser() && window.QRScanner ? /*#__PURE__*/_react["default"].createElement(_index["default"], {
        className: _SettingsCordova["default"].contentButton,
        onClick: _QRCode.scanQrCode
      }, (0, _strings.getString)('SCAN_QR_CODE')) : null, this.renderTargetAndDrupalSettingsItems(), _config["default"].showEqueoUserAgreement && /*#__PURE__*/_react["default"].createElement(_index["default"], {
        className: _SettingsCordova["default"].contentButton,
        onClick: this.showUserAgreement
      }, (0, _strings.getString)('SHOW_USER_AGREEMENT')), _config["default"].showEqueoDataPrivacy && /*#__PURE__*/_react["default"].createElement(_index["default"], {
        className: _SettingsCordova["default"].contentButton,
        onClick: this.showDataPrivacy
      }, (0, _strings.getString)('SHOW_DATA_PRIVACY')), _config["default"].showEqueoImprint && /*#__PURE__*/_react["default"].createElement(_index["default"], {
        className: _SettingsCordova["default"].contentButton,
        onClick: this.showImprint
      }, (0, _strings.getString)('SHOW_IMPRINT')), _DeviceInfoHelper["default"].isBrowser() && _config["default"].useWebLogin ? /*#__PURE__*/_react["default"].createElement(_index["default"], {
        className: _SettingsCordova["default"].contentButton,
        onClick: this.logOut
      }, (0, _strings.getString)('LOG_OUT')) : null, _config["default"].showResetTest ? /*#__PURE__*/_react["default"].createElement(_index["default"], {
        className: _SettingsCordova["default"].contentButton,
        onClick: this.resetTest
      }, (0, _strings.getString)('RESET_TEST')) : null, _config["default"].showFeedbackMail ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _SettingsCordova["default"].contactContainer
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: _SettingsCordova["default"].contact,
        id: MAIL_ID,
        href: "mailto:".concat(_config["default"].feedbackMail),
        dangerouslySetInnerHTML: {
          __html: (0, _strings.getString)('CONTACT', [_config["default"].feedbackMail])
        }
      })) : null, _config["default"].qrCodeLogin && loggedIn && /*#__PURE__*/_react["default"].createElement(_QRCodeLogin["default"], null), _config["default"].qdQrCodeLogin && loggedIn && /*#__PURE__*/_react["default"].createElement(_QRCodeLogin["default"], {
        forQD: true
      }), _config["default"].qrCodeReferrer && /*#__PURE__*/_react["default"].createElement(_QRCodeReferrer["default"], null)), _config["default"].feedbackText && /*#__PURE__*/_react["default"].createElement("div", {
        className: _SettingsCordova["default"].text,
        dangerouslySetInnerHTML: {
          __html: _config["default"].feedbackText
        }
      }));
    }
  }]);
  return SettingsCordova;
}(_DataStoreComponent2["default"]);

SettingsCordova.propTypes = {
  setTitle: _propTypes["default"].func,
  setBackButtonFunc: _propTypes["default"].func,
  updateContent: _propTypes["default"].func,
  isEmbedded: _propTypes["default"].bool
};
var _default = SettingsCordova;
exports["default"] = _default;